export default __webpack_public_path__ + "static/media/cert-hkgcsmeaa.adfb5613.jpg";